import i18n from '@/libs/i18n';
import Vue from 'vue';
export default {
  UPDATE_WINDOW_WIDTH(state, val) {
    state.windowWidth = val;
  },
  TOGGLE_OVERLAY(state, val) {
    state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay;
  },
  SET_LANG(state, lang) {
    if (state.locales.includes(lang.locale)) {
      state.language = lang;
    }
  },
  setLocale(state, locale) {
    if (state.locales.includes(locale)) {
      state.currentLocale = locale;
    }
  },
  successMessage: (state, data) => {
    Vue.$wameedNotify({ title:  i18n.t('success_messages.' + data), type: 'success' });
    state.messages = 'success';
  },
  failMessage: (state, data) => {
    state.messages = 'error';
    Vue.$wameedNotify({ title:  i18n.t('error_messages.' + data), type: 'fail' });

  },
  loadingFinish: (state) => {
    state.loading = false;
  },
  loadingStart: (state) => {
    state.loading = true;
  },
};
